import React from 'react';

const TooltipTextWrapper = ({text, exampleTitle, exampleText}) =>
    <div>
        {text}
        {
            exampleTitle && exampleText ?
                <div>
                    {`${exampleTitle}:`} <code>{exampleText}</code>
                </div> : null
        }
    </div>;

export {
    TooltipTextWrapper
}


// WEBPACK FOOTER //
// ./src/components/common/tooltipTextWrapper/index.jsx